const TYPE_ERROR_TYPE = 'TypeError';
const ILLEGAL_INVOCATION_MESSAGE = 'Illegal invocation';
const INJECTED_CONTENT_SCRIPT_FRAME = 'inject_content.js';
const COOKIE_CONTROL_DIALOG_INIT_FRAME = 'CookieControl.Dialog.init';

type FrameLike = {
  filename?: string;
  function?: string;
  abs_path?: string;
};

type ExceptionLike = {
  type?: string;
  value?: string;
  stacktrace?: {
    frames?: FrameLike[];
  };
};

type CreateEventEventLike = {
  exception?: {
    values?: ExceptionLike[];
  };
};

const LIPS_SOURCE_PATTERNS = ['/_next/', '/src/', 'lips.org.uk'];

function framePath(frame: FrameLike): string {
  return `${frame.abs_path ?? ''} ${frame.filename ?? ''}`;
}

function isLipsSourcePath(frame: FrameLike): boolean {
  return LIPS_SOURCE_PATTERNS.some((pattern) =>
    framePath(frame).includes(pattern),
  );
}

function hasFrameWithPathPattern(
  frames: FrameLike[],
  pattern: string,
): boolean {
  return frames.some((frame) => framePath(frame).includes(pattern));
}

function hasFrameWithFunctionPattern(
  frames: FrameLike[],
  pattern: string,
): boolean {
  return frames.some((frame) => (frame.function ?? '').includes(pattern));
}

export function isKnownInjectedCreateEventError(event: unknown): boolean {
  if (event === null || typeof event !== 'object') {
    return false;
  }

  const candidate = event as CreateEventEventLike;
  const exceptions = candidate.exception?.values;

  if (
    !exceptions?.some(
      (exception) =>
        exception.type === TYPE_ERROR_TYPE &&
        exception.value === ILLEGAL_INVOCATION_MESSAGE,
    )
  ) {
    return false;
  }

  const frames = exceptions.flatMap(
    (exception) => exception.stacktrace?.frames ?? [],
  );

  if (!hasFrameWithPathPattern(frames, INJECTED_CONTENT_SCRIPT_FRAME)) {
    return false;
  }

  if (!hasFrameWithFunctionPattern(frames, COOKIE_CONTROL_DIALOG_INIT_FRAME)) {
    return false;
  }

  return !frames.some(isLipsSourcePath);
}
